import {
  // otherComponents,
  // formCreate,
  panguComponents,
  filters,
  filter,
  moment,
  panguStore,
  crudEditOfDesign,
  shoppingModel,
  shoppingModelPlus,
  portal,
  portalItem,
  countTo,
  cellBoolean,
} from './components/index'
import pgMessage from './components/pgMessage/confirmTip'
import iView from 'iview'

const appMain = {
  install: function (Vue, options) {
    Vue.use(iView, {
      transfer: true,
    })

    // Vue.use(formCreate)
    Vue.use(panguComponents)
    Vue.use(filters)
    Vue.use(pgMessage)
    Vue.prototype.$Message.config({ duration: 5 }) //默认设置提示时间5s
    if (options) {
      Object.keys(options).forEach((key) => {
        if (typeof options[key] === 'function') {
          options[key](Vue)
        }
      })
    }
  },
}
const ShoppingModel = {
  install(Vue) {
    Vue.component('ShoppingModel', shoppingModel)
  },
}
const ShoppingModelPlus = {
  install(Vue) {
    Vue.component('ShoppingModelPlus', shoppingModelPlus)
  },
}

export default appMain

export {
  // ...otherComponents,
  // formCreate,
  panguComponents,
  filters,
  filter,
  moment,
  panguStore,
  appMain,
  crudEditOfDesign,
  ShoppingModel,
  ShoppingModelPlus,
  portal,
  portalItem,
  countTo,
  cellBoolean,
}
